import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { BrandingResourcesRoutingModule } from './branding-resources-routing.module';


@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    BrandingResourcesRoutingModule
  ]
})
export class BrandingResourcesModule { }
